/**
 * 场景路由页（S3）的文案。命名空间 `visualGameAdmin.llm.modes.*`。
 *
 * 页面上不放说明性文字：链怎么走、重复的 (厂商, 模型) 意味着什么，都写在 `plan/llm-admin/` 里。
 * 能变成行为的已经是行为了（只剩一步时删除键 disabled、没有兜底时「加一步」是主按钮）。
 *
 * `en` 与 `zh` 的 key 集必须逐字相同 —— `test/i18n.test.js` 拍平后逐项比对六个语种
 * （`ja`/`es`/`id`/`pt` 是 `structuredClone(en)` 的桩，自动跟随）。
 */

export const en = {
  title: 'Scene routing',
  required: 'Required',
  optional: 'Optional',
  unsaved: 'Unsaved',
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled',
  },
  chain: {
    primary: 'Primary',
    fallback: 'Fallback {order}',
    step: 'Provider / model',
    add: 'Add a step',
    remove: 'Remove',
    keepOne: 'Keep at least one step',
    up: 'Move up',
    down: 'Move down',
    placeholder: 'Pick an enabled (provider, model)',
  },
  actions: {
    save: 'Save chain',
    reset: 'Discard changes',
  },
  errors: {
    incomplete: 'No provider or model picked',
    unroutable: 'Provider or model is disabled',
  },
  empty: {
    title: 'No mode is configured',
    description: 'Create and enable a model before configuring scene routing',
    action: 'Manage models',
  },
  noOptions: {
    title: 'Nothing to route to',
    description: 'Enable a provider and a model first',
    action: 'Manage providers',
  },
  toast: {
    saved: 'Chain saved',
    failed: 'The change was refused',
  },
}

export const zh = {
  title: '场景路由',
  required: '必需',
  optional: '可选',
  unsaved: '未保存',
  status: {
    enabled: '已启用',
    disabled: '已停用',
  },
  chain: {
    primary: '主力',
    fallback: '兜底 {order}',
    step: '厂商 / 模型',
    add: '加一步',
    remove: '删除',
    keepOne: '至少留一步',
    up: '上移',
    down: '下移',
    placeholder: '选一个已启用的 (厂商, 模型)',
  },
  actions: {
    save: '保存链',
    reset: '撤销改动',
  },
  errors: {
    incomplete: '还没选厂商和模型',
    unroutable: '厂商或模型已停用',
  },
  empty: {
    title: '还没有配置任何场景',
    description: '需要先创建并启用模型，再配置场景路由',
    action: '管理模型',
  },
  noOptions: {
    title: '没有可路由的 (厂商, 模型)',
    description: '先启用一个厂商和模型',
    action: '管理厂商',
  },
  toast: {
    saved: '链已保存',
    failed: '这次改动被拒绝了',
  },
}
